const childPerfMarkers = {};

export function getChildPerfMarkers({
  perfMarker,
  configs,
  cardSize,
}) {
  if (!configs) {
    return childPerfMarkers;
  }
  configs.forEach((config, index) => {
    if (!childPerfMarkers[config.typeId] && index < cardSize) {
      const childPerfMarker = perfMarker.createChild(config.typeId);
      childPerfMarkers[config.typeId] = childPerfMarker;
      childPerfMarker.willInit();
    } else if (!childPerfMarkers[config.typeId]) {
      // If we don't show cards in view port, we don't need to create perf markers for them
      childPerfMarkers[config.typeId] = {
        willFetchData: () => {},
        willRender: () => {},
        done: () => {},
      };
    }
  });

  return childPerfMarkers;
}
